export default {
  methods: {
    async fetchPrognosa(getKlinikId) {
      let result = [];
      try {
        const res = await this.$axios.get(`bpjs/prognosa?klinik_id=${getKlinikId}`);
        const { metaData, response } = res.data;
        if (metaData.code == 200 && response) result = response.list.map(v => ({value: v.kdPrognosa, label: v.nmPrognosa}));
      } catch (err) {
        // console.warn(err)
      }
      return result;
    },
    async fetchFaktorRujukan(getKlinikId) {
      let result = [];
      try {
        const res = await this.$axios.get(`bpjs/tacc?klinik_id=${getKlinikId}`);
        const { metaData, response } = res.data;
        if (metaData.code == 200 && response) result = response.list.map(v => ({value: v.kdTacc, label: v.nmTacc, optAlasan: v.alasanTacc}));
      } catch (err) {
        // console.warn(err)
      }
      return result;
    },
  }
};
